var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:{response: _vm.isReply}},[(_vm.$slots.default)?_vm._t("default"):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }